// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2rcAb","legacyBtn":"MutateMid_legacyBtn__3r8sz"};